
<div :class="classes(n())">
  <Popup
    :class="classes(n('actionsheet'))"
    :visible="visible"
    position="bottom"
    :close-on-click-overlay="true"
    teleport="body"
    @update:visible="onUpdateVisible"
    @clickOverlay="onClose"
  >
    <div :class="classes(n('actionsheet-content'))">
      <div v-if="title" :class="classes(n('actionsheet-content-title'))">
        {{ title }}
      </div>
      <div :class="classes(n('actionsheet-content-actions'))">
        <ActionSheetActionItem
          v-for="(item, index) in actions"
          :key="item.key"
          :class="classes(n('actionsheet-content-actions-item'))"
          :action="item"
          @click="onSelect(item, index)"
        />
      </div>
      <div
        :class="classes(n('actionsheet-content-cancel'))"
        role="button"
        :aria-label="cancelText || '取消'"
        @click="onCancel"
      >
        {{ cancelText || '取消' }}
      </div>
    </div>
  </Popup>
</div>
